import React from 'react';
import { TrendingUpIcon, BarChart3Icon, CoinsIcon } from 'lucide-react';
export function IncomeSection() {
  return <section className="py-12 mb-12 bg-amber-50 rounded-lg" data-id="element-244">
      <div className="max-w-3xl mx-auto px-4" data-id="element-245">
        <h2 className="text-2xl md:text-3xl font-serif font-bold text-center text-amber-900 mb-8" data-id="element-246">
          Oportunidad de Negocio Real
        </h2>
        <p className="text-lg text-amber-800 text-center font-medium mb-8" data-id="element-247">
          Historias de éxito de nuestros alumnos
        </p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8" data-id="element-248">
          <div className="bg-white p-6 rounded-lg shadow-sm flex flex-col items-center text-center" data-id="element-249">
            <div className="bg-amber-100 p-4 rounded-full mb-4" data-id="element-250">
              <CoinsIcon size={32} className="text-amber-600" data-id="element-251" />
            </div>
            <h3 className="text-lg font-bold text-amber-900 mb-2" data-id="element-252">
              $500+ dólares
            </h3>
            <p className="text-gray-700" data-id="element-253">
              Ingresos promedio mensuales de alumnos vendiendo milhojas desde
              casa.
            </p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-sm flex flex-col items-center text-center" data-id="element-254">
            <div className="bg-amber-100 p-4 rounded-full mb-4" data-id="element-255">
              <TrendingUpIcon size={32} className="text-amber-600" data-id="element-256" />
            </div>
            <h3 className="text-lg font-bold text-amber-900 mb-2" data-id="element-257">
              10x Retorno
            </h3>
            <p className="text-gray-700" data-id="element-258">
              Con solo una milhojas vendida recuperas tu inversión en el curso.
            </p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-sm flex flex-col items-center text-center" data-id="element-259">
            <div className="bg-amber-100 p-4 rounded-full mb-4" data-id="element-260">
              <BarChart3Icon size={32} className="text-amber-600" data-id="element-261" />
            </div>
            <h3 className="text-lg font-bold text-amber-900 mb-2" data-id="element-262">
              15+ Milhojas
            </h3>
            <p className="text-gray-700" data-id="element-263">
              Producción mensual promedio de nuestros alumnos emprendedores.
            </p>
          </div>
        </div>
        <div className="text-center" data-id="element-264">
          <a href="#comprar" className="inline-block bg-amber-600 hover:bg-amber-700 text-white font-bold py-3 px-8 rounded-full text-lg transition-colors shadow-md" data-id="element-265">
            ¡Comienza Tu Negocio Hoy!
          </a>
        </div>
      </div>
    </section>;
}